import React, { useEffect, useState } from 'react';
import { Tree, Button, Flex, Spin } from 'antd';
import type { TreeDataNode, TreeProps } from 'antd';
import { mdlBranch } from '../../models/domain/Branch';
import { useMutation, useQuery } from 'react-query';
import { UserService } from '../../services/UserService';
import { mdlUserPermissionListRequest } from '../../models/service-models/user/UserPermissionListRequest';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import { ObjectHelper } from '../../utils/ObjectHelper';

export type UserTableProps = {
    userId?: string;
    hotelId?: string;
    callback?: Function;
};

const UserPermissions = (props: UserTableProps) => {
    const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
    const [treeData, setTreeData] = useState<TreeDataNode[]>([]);

    useEffect(() => {
        if (!data && props.userId) {
            console.log(props)
            getUserPermissionList();
        }
    }, []);

    const {
        data,  // Varsayılan olarak boş bir dizi atanabilir
        isLoading,
        isFetched,
        refetch: getUserPermissionList
    } = useQuery(
        ["getUserPermissionList", props.userId],
        () => {
            if (props.userId && props.hotelId) {
                const request: mdlUserPermissionListRequest = { hotelId: props.hotelId, userId: props.userId };
                return UserService.UserPermissionList(request);
            }
        },
        {
            staleTime: 0,
            refetchOnWindowFocus: false,
            enabled: !!props.userId,
            cacheTime: 0
        }
    );
    useEffect(() => {
        if (data?.body?.data.list) {
            console.log(getDefaultCheckedKeys(data.body?.data.list))
            setCheckedKeys(getDefaultCheckedKeys(data.body?.data.list));
            setTreeData(mapToTreeData(data.body.data.list))

        }
    }, [data]);

    const mapToTreeData = (data: any) => {
        return data.map((item: mdlBranch) => ({
            title: item.name,
            key: item.branchId,
            children: item.children && item.children.length > 0 ? mapToTreeData(item.children) : [],
        }));
    };

    const getDefaultCheckedKeys = (data: mdlBranch[]): string[] => {
        return data.reduce((acc: string[], item: mdlBranch) => {
            if (item.hasPermission == 1) {
                acc.push(item.branchId!);
            }
            if (item.children && item.children.length > 0) {
                acc.push(...getDefaultCheckedKeys(item.children));
            }
            return acc;
        }, []);
    };

    const onCheck: TreeProps['onCheck'] = (checkedKeysValue) => {
        console.log(checkedKeys)
        setCheckedKeys(checkedKeysValue as React.Key[]);
    };

    const { mutateAsync: savePermissions, isLoading: isSaving } = useMutation(
        async () => {
            const payload = {
                userId: props.userId,
                hotelId: props.hotelId,
                isAllHotels: false,
                permissions: checkedKeys as [],
            };
            console.log('Sending payload:', payload);
            return UserService.PermissionListUpdate(payload);
        },
        {
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                    props.callback && props.callback();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    return (
        <Spin spinning={isSaving || isLoading}>

            {
                checkedKeys
                &&
                <>

                    <Tree
                        checkable
                        checkedKeys={checkedKeys}
                        onCheck={onCheck}
                        treeData={treeData}
                    />
                    <Flex align={"center"} justify="flex-end">
                        <Button
                            type="primary"
                            onClick={() => savePermissions()}
                            loading={isSaving}
                            style={{ marginTop: 16 }}
                        >
                            {t("common.save")}
                        </Button>
                    </Flex>
                </>
            }

        </Spin>

    );
};

export default UserPermissions;
